module.exports = __webpack_public_path__ + "img/icon-weibo.d1b5852c.svg";